<template lang="pug">
  .recalled
    GenericTable(ref="grid" :loading="loading")
      tr(slot="thead")
        th Package
        th Product
        th Count
      tr(v-for="i in inventory")
        td {{i.packageName}}
        td
          span(v-if="i.productName") {{i.productName}}
        td {{i.count}}
    .pt20
    .panel.panel-default(v-if="recall")
      .panel-heading.panel-title Active Recalls
      .panel-body
        PillsList(:items="recall" :clickable="true" @itemClick="goToRecall")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import GenericPagination from '@/components/common/GenericPagination'
import TrackNTrace from '@/service/apis/TrackNTrace'
import PillsList from '@/components/common/PillsList'

export default {
  data: () => ({
    inventory: null,
    recall: null,
    loading: false
  }),
  created() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.loading = true
      TrackNTrace.getActiveLocationRecalls(this.locationId)
        .then((resp) => {
          this.inventory = resp.data.inventory
          this.recall = resp.data.recallIds.map((r) => ({ name: r }))
        })
        .catch((e) => { this.$emit('error', e) })
        .then(() => {
          this.loading = false
        })
    },
    goToRecall(data) {
      this.$router.push(`/trackntrace/configuration/recall/${data.name}`)
    }
  },
  computed: {
    locationId() {
      return parseInt(this.$route.params.id, 10)
    }
  },
  components: {
    GenericTable,
    GenericPagination,
    PillsList
  },
}
</script>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/locationportal/components/Recalled.vue